import { Alert } from "antd";
import { widgetExecutionsListSubscription } from "containers/Executions/Executions.type";
import { getRelativeUrl } from "utils/service";
import { getStatusMessageText, testHTTP } from "utils/utils";

export const isEnabledField = {
    name: "is_enabled",
    component: "switch",
    fieldProps: {
        label: "Enabled",
    },
};

export const enabledScheduleField = (additionalAttributes = {}) => ({
    ...isEnabledField,
    fieldAttr: { ...(isEnabledField.fieldAttr ?? {}), ...additionalAttributes },
    fieldProps: {
        ...isEnabledField.fieldProps,
        fieldNote: (currentValues) =>
            currentValues?.is_enabled ? (
                <Alert
                    message="Changing the schedule is not possible while it is enabled. To change the schedule, disable it, make your changes, and then enable it again."
                    type="info"
                    showIcon
                />
            ) : null,
    },
});

export const getLatestExecutions = (selector) => ({
    uid: "widget-1",
    title: "Latest Executions",
    className: "w-full",
    component: "LatestList",
    selector: `${selector}_latest_executions`,
    websocket: true,
    graphql: {
        subscription: widgetExecutionsListSubscription,
        variables: {
            limit: 5,
            order: "-created_at",
        },
    },
    dto: ({ stats }) => [
        ...(stats?.execution_list?.execution_list?.map((item) => ({
            ...item,
            link: getRelativeUrl("execution", item?.id),
            name: getStatusMessageText(item?.message, item?.status),
        })) || []),
    ],
});

export const getUrlDTO = (url) =>
    !!testHTTP(url) ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
            {url}
        </a>
    ) : (
        <div>{url}</div>
    );
